export enum Variant {
  DEFAULT = 'default',
  DROPDOWN = 'dropdown',
}
